import type { ChangeEventHandler } from "react";

import type { TInputProps } from "@/ui/components/form/Input";
import {
  REQUEST_LOGIN_CODE_FIELD_CLASS,
  REQUEST_LOGIN_CODE_SUBMIT_DEFAULTS,
  type TRequestLoginCodeInputProps,
  type TRequestLoginCodeMessages,
  type TRequestLoginCodeSubmitProps,
  type TRequestLoginCodeTranslate,
} from "./RequestLoginCode.config";
import { cn } from "@/ui/lib/utils";

export const getRequestLoginCodeMessages = (
  t: TRequestLoginCodeTranslate,
): TRequestLoginCodeMessages => ({
  emailLabel: t("emailLabel"),
  emailPlaceholder: t("emailPlaceholder"),
  submitLabel: t("submitLabel"),
});

export const getRequestLoginCodeEmailProps = (
  email: TRequestLoginCodeInputProps,
  messages: TRequestLoginCodeMessages,
): TInputProps => {
  const {
    label,
    onValueChange,
    placeholder,
    ...props
  } = email;

  const onChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    onValueChange(event.target.value);
  };

  return {
    ...props,
    label: label ?? messages.emailLabel,
    name: "email",
    type: "email",
    autoComplete: email.autoComplete ?? "email",
    placeholder: placeholder ?? messages.emailPlaceholder,
    className: cn(REQUEST_LOGIN_CODE_FIELD_CLASS, props.className),
    onChange,
  };
};

export const getRequestLoginCodeSubmitProps = (
  submit: TRequestLoginCodeSubmitProps,
  messages: TRequestLoginCodeMessages,
) => {
  const {
    label,
    ...props
  } = submit;

  return {
    label: label ?? messages.submitLabel,
    props: {
      ...REQUEST_LOGIN_CODE_SUBMIT_DEFAULTS,
      ...props,
    },
  };
};
